import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/varietyShows";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 flex-shrink-0 cursor-pointer"
          >
            <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-heart-fill text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-900 whitespace-nowrap">
              红桃影院
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                className={`flex items-center gap-1 px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.startsWith("/category")
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                分类浏览
                <i
                  className={`ri-arrow-down-s-line text-xs transition-transform ${
                    isCategoryOpen ? "rotate-180" : ""
                  }`}
                ></i>
              </button>

              {isCategoryOpen && (
                <div className="absolute top-full mt-2 left-0 bg-background-50 border border-background-200/80 rounded-xl shadow-lg py-2 w-48">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className={`${cat.icon} text-primary-500 w-4 h-4 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center bg-background-100 rounded-full px-4 py-2 gap-2">
              <i className="ri-search-line text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <input
                type="text"
                placeholder="搜索综艺节目..."
                className="bg-transparent text-sm text-foreground-700 placeholder-foreground-300 outline-none w-40"
              />
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
            >
              <i
                className={`text-foreground-700 text-lg ${
                  isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"
                }`}
              ></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 bg-background-50">
            <nav className="flex flex-col gap-1">
              <Link
                to="/"
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer"
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-3"
                >
                  <i className={`${cat.icon} text-primary-500 w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer"
              >
                关于我们
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}